export const ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  TRAINER: 'trainer',
  COHORT: 'cohort',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

export const RoleLabels: Record<Role, string> = {
  [ROLES.USER]: 'User',
  [ROLES.ADMIN]: 'Administrator',
  [ROLES.TRAINER]: 'Trainer',
  [ROLES.COHORT]: 'Cohort',
};
